import React, { FunctionComponent, useState } from 'react';
import { Typography } from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LoadingButton } from '@mui/lab';
import JsonView from '@uiw/react-json-view';
import dayjs from 'dayjs';
import {
  ButtonContainer,
  StyledEditablePropertyItemContainer
} from './getDeferEventItemStyles';
import Strings from '../../i18n';
import { GetDeferEventItemProps } from './getDeferEventItemProps';

export const GetDeferEventItem: FunctionComponent<GetDeferEventItemProps> = ({
  nameCommand,
  loading,
  onSave,
  data,
  isSetDefer
}) => {
  const [value, setValue] = useState<dayjs.Dayjs | null>(dayjs());
  return (
    <StyledEditablePropertyItemContainer>
      <Typography textAlign="center">{nameCommand}</Typography>
      {data !== undefined && (
        <JsonView
          value={data.extraMessages}
          displayDataTypes={false}
          displayObjectSize={false}
          indentWidth={2}
          shortenTextAfterLength={1000}
        />
      )}
      {isSetDefer && (
        <DateTimePicker
          sx={{ marginTop: '10px' }}
          value={value}
          onChange={(newValue) => setValue(newValue)}
        />
      )}

      <ButtonContainer>
        <LoadingButton
          variant="contained"
          sx={{ height: '40px' }}
          loading={loading}
          onClick={isSetDefer ? () => onSave(value) : () => onSave()}
        >
          {Strings.common.send}
        </LoadingButton>
      </ButtonContainer>
    </StyledEditablePropertyItemContainer>
  );
};
